import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";
import { AnnouncementPayload } from "../models";

export const useUpdateAnnouncement = ({
    onSuccess,
    onError,
}: {
    onSuccess?: () => void;
    onError?: (err: unknown, key: string) => void;
}) => {
    const {
        trigger: triggerUpdateAnnouncement,
        isMutating: isLoadingUpdateAnnouncement,
    } = useSWRMutation(
        "/api/notification-management/v1/announcements",
        (
            url: string,
            {
                arg,
            }: {
                arg: {
                    announcementId: string;
                    body: AnnouncementPayload;
                };
            }
        ) =>
            fetcher(`${url}/${arg.announcementId}`, {
                options: {
                    method: API_REST_METHODS.PUT,
                    body: JSON.stringify(arg.body),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerUpdateAnnouncement,
        isLoadingUpdateAnnouncement,
    };
};
